import React from 'react';
export function ProductShowcase() {
  const rowColors = ['bg-blue-700', 'bg-green-700', 'bg-red-700', 'bg-purple-700', 'bg-amber-700', 'bg-teal-700'];
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border pt-[10px] pb-[10px]" data-id="element-231">
      <div className="max-w-5xl mx-auto text-center" data-id="element-232">
        <div data-id="element-233">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-4" data-id="element-234">
            <span className="text-xl" data-id="element-235">🌍</span> PROFEPACK
          </div>

          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 uppercase text-brand-accent" data-id="element-236">
            MegaPack Ciencias Sociales Lista
          </h2>

          <div className="mb-12 flex flex-col gap-2" data-id="element-237">
            <p className="text-xl md:text-2xl text-white font-bold" data-id="element-238">
              6 tomos organizados por grado.
            </p>
            <p className="text-base md:text-lg text-white/70 max-w-3xl mx-auto font-medium leading-relaxed" data-id="element-239">
              Más de 300 actividades con solucionario. 6 bonos estratégicos.
              Todo listo para usar desde hoy.
            </p>
          </div>
        </div>

        {/* Grid Showcase */}
        <div className="relative max-w-3xl mx-auto mb-16" data-id="element-240">
          <div className="grid grid-cols-6 gap-2 md:gap-3 mb-6" data-id="element-241">
            {rowColors.map((color, i) => <div key={`r1-${i}`} className={`${color} border-2 border-brand-accent rounded-lg md:rounded-xl aspect-[3/4] flex items-end justify-center pb-2 md:pb-4 shadow-lg`} data-id="element-242">
                <span className="text-white font-bold text-sm md:text-xl" data-id="element-243">
                  {i + 1}.º
                </span>
              </div>)}
          </div>

          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 bg-brand-card border-2 border-brand-accent text-brand-accent px-6 py-2 rounded-full font-bold text-sm md:text-base whitespace-nowrap shadow-xl z-10" data-id="element-244">
            6 TOMOS COMPLETOS
          </div>
        </div>

        {/* Feature Badges */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-3xl mx-auto mt-12" data-id="element-245">
          {['✅ Por grado (1.º a 6.º)', '✅ Con solucionario docente', '✅ Con efemérides incluidas', '✅ Con diseño infantil-didáctico', '✅ Alineado a los NAP', '✅ Con bibliografía curricular'].map((item, i) => <div key={i} className="bg-brand-card border border-brand-accent px-5 py-2.5 rounded-full flex items-center gap-2 shadow-sm" data-id="element-246">
              <span className="font-medium text-white/90 text-sm md:text-base" data-id="element-247">
                {item}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}